module.exports = __webpack_public_path__ + "static/media/icon_delete.dd352662.svg";